module.exports = {
  VALIDATING: 'VALIDANDO', // The key is being validated via email/sms
  PENDING: 'PENDENTE', // The key will be registered on dict
  ERROR: 'ERRO', // Some error happened when registering the pix key
  REGISTERED: 'REGISTRADA', // They key is registered on dict and belongs to our customer
  PENDING_REMOVAL: 'REMOCAO_PENDENTE', // The key is marked for removal
  REMOVED: 'REMOVIDA', // They key has been removed
  // Claimer
  WAITING_CLAIM: 'AGUARDANDO_REIVINDICACAO', // The key is already registered in someone else's name. Our customer needs to claim the key
  WAITING_PORTABILITY: 'AGUARDANDO_PORTABILIDADE', // The key is already registered in another account from our customer. He needs to request the portability
  CLAIM_REQUESTED: 'REIVINDICACAO_SOLICITADA', // claim requested, but the donor psp did not accepted the request yet
  PORTABILITY_REQUESTED: 'PORTABILIDADE_SOLICITADA', // portability requested, but the donor psp did not accepted the request yet
  CLAIM_IN_PROGRESS: 'REIVINDICACAO_EM_ANDAMENTO', // Waiting for another person to give up their key
  PORTABILITY_IN_PROGRESS: 'PORTABILIDADE_EM_ANDAMENTO', // Waiting for our customer to confirm the portability in his other account
  // Donor
  WAITING_PORTABILITY_APPROVAL: 'AGUARDANDO_CONFIRMACAO_DE_PORTABILIDADE', // Waiting for our customer to confirm the donation of his key
  WAITING_CLAIM_APPROVAL: 'AGUARDANDO_CONFIRMACAO_DE_REIVINDICACAO' // Waiting for our customer to confirm the donation of his key
};
